"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as styles from "./Separator-css";
import classNames from "classnames";
import { makeSpacingVariants } from "../../../utils/makeSpacingVariants";
export const Separator = (_a) => {
  var _b = _a, {
    direction = "horizontal",
    size = "",
    className,
    spacing,
    outset
  } = _b, props = __objRest(_b, [
    "direction",
    "size",
    "className",
    "spacing",
    "outset"
  ]);
  return /* @__PURE__ */ React.createElement(
    "div",
    __spreadValues({
      className: classNames(
        styles.separator(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, direction === "horizontal" ? makeSpacingVariants({ paddingBlock: spacing }) : {}), direction === "horizontal" ? makeSpacingVariants({ marginInline: outset }) : {}), direction === "vertical" ? makeSpacingVariants({ paddingInline: spacing }) : {}), direction === "vertical" ? makeSpacingVariants({ marginBlock: outset }) : {})),
        className
      ),
      role: "separator",
      "aria-orientation": direction,
      style: assignInlineVars({ [styles.size]: size })
    }, props)
  );
};
